module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-global-bg-2-81f14c25d6f7aad158fdf0f6b1131cda.png";